import { h } from 'preact'
import { memo } from 'preact/compat'
import PropTypes from 'prop-types'
import { useTranslations } from '../../../hooks/useTranslations'
import SelectBox from '../../Common/SelectBox'
import GroupSelectBox from '../../Common/GroupSelectBox'
import USStates from '../../../assets/USStates'
import CAStates from '../../../assets/CAStates'
import UKCounties from '../../../assets/UKCounties'

const statesOptions = {
  US: USStates,
  CA: CAStates,
  GB: UKCounties,
}

const AddressSelectBox = ({
  register,
  errors,
  field,
  className,
  selectBoxClassName,
  country,
}) => {
  const l10n = useTranslations()

  const SelectBoxComponent = country === 'GB' ? GroupSelectBox : SelectBox

  return (
    <SelectBoxComponent
      label={field.title}
      className={className}
      selectProps={{
        'data-testid': 'field-select-box',
        name: field.name,
        id: field.name,
        autocomplete: field.autocomplete,
        className: selectBoxClassName,
        ...register(field.name, { required: field.required }),
      }}
      hasError={Boolean(errors[field.name])}
      options={statesOptions[country]}
      errorMessage={l10n.t('This field is required')}
    />
  )
}

AddressSelectBox.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  className: PropTypes.string,
  selectBoxClassName: PropTypes.string,
  country: PropTypes.string,
  field: PropTypes.exact({
    name: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    autocomplete: PropTypes.string,
    available: PropTypes.bool,
  }).isRequired,
}

export default AddressSelectBox
